export default __webpack_public_path__ + "static/404-image-2892667451649271eb1d3cd73c3db614.jpg";